<script>
import { REMOVE_FROM_ROUTE_NAME } from '@/store/actions/router';
/**
 * @description Компонент кнопки назад.
 * @type {object}
 */
export default {
  name: 'ButtonBack',
  functional: true,
  props: {
    title: { default: 'Назад', type: String },
  },
  render(createElement, { parent, props }) {
    const canBack = window.history.length > 2;
    const onClick = () => {
      const fromRoute = parent.$store.getters.getFromRoute;
      if (fromRoute) {
        parent.$router.push(fromRoute);
        parent.$store.dispatch(REMOVE_FROM_ROUTE_NAME);
      } else {
        parent.$router.back();
      }
    };
    return canBack
      ? createElement(
        'button',
        {
          attrs: { type: 'button' },
          on: { click: onClick },
          staticClass: 'button-back',
        },
        props.title,
      ) : createElement();
  },
};
</script>

<style scoped lang="scss">
.button-back {
  color: var(--action-color);
  display: flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  margin: 0 0 10px 0;
  &:before {
    content: '';
    background-image: url('@/assets/img/arrow/arrow-blue.svg');
    background-position: center;
    background-size: contain;
    width: 12px;
    height: 12px;
    display: block;
  }
  &:hover {
    text-decoration: underline;
  }
}
</style>
